import { openComponentInPopup } from './common';
import OrderMatrix from './order-matrix';
import { PopupOptions, PopupWidth } from './popup';
import ProductCount from './product-count';

export default class OrderMatrixLink {
    link: HTMLElement;
    onOrderMatrixSubmit: (productCounts: ProductCount[]) => void;
    onEnterCalculation: (productCounts: ProductCount[]) => void;
    onProductsAdded: (productCounts: ProductCount[]) => void;
    popupWidth: PopupWidth;

    constructor(
        link: HTMLElement,
        onOrderMatrixSubmit: (productCounts: ProductCount[]) => void,
        onEnterCalculation: (productCounts: ProductCount[]) => void
    ) {
        this.link = link;
        this.popupWidth = link.dataset.popupWidth as PopupWidth ?? PopupWidth.Large;
        this.onOrderMatrixSubmit = onOrderMatrixSubmit;
        this.onEnterCalculation = onEnterCalculation;
    }

    public async init(groupCartItemId: string = null): Promise<void> {
        this.link.addEventListener('click', async event => {
            event.preventDefault();
            await this.openOrderMatrix(groupCartItemId);
        });
    }

    private async openOrderMatrix(groupCartItemId: string): Promise<void> {
        await openComponentInPopup(
            OrderMatrix.componentName,
            [{ key: 'groupCartItem', value: groupCartItemId }],
            { id: 'order-matrix-popup', width: this.popupWidth, closeOnBgClick: true } as PopupOptions, true);
        new OrderMatrix(document.getElementById('order-matrix-popup'), this.onOrderMatrixSubmit, this.onEnterCalculation);
    }
}
